import React from 'react';
import clsx from 'clsx';

const Badge = ({ 
  children, 
  variant = 'default',
  size = 'md',
  className,
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full font-body';
  
  // Badge variants based on UX Base Design specifications
  const variants = {
    // Status badges
    default: 'bg-gray-100 text-gray-800',
    primary: 'bg-blue-100 text-primary',
    secondary: 'bg-gray-100 text-secondary',
    
    // Status indicators
    success: 'bg-emerald-100 text-emerald-800',
    warning: 'bg-amber-100 text-amber-800', 
    danger: 'bg-red-100 text-red-800',
    error: 'bg-red-100 text-red-800', // Alias for danger
    info: 'bg-blue-100 text-blue-800',
    
    // Tier system badges (exact from UX spec)
    'basic': 'bg-[#E5E7EB] text-[#374151]',           // badge-basic
    'featured': 'bg-[#DBEAFE] text-[#1D4ED8]',        // badge-featured  
    'spotlight': 'bg-[#FEF3C7] text-[#B45309]',       // badge-spotlight
    
    // Alternative tier names for compatibility
    'tier-basic': 'bg-[#E5E7EB] text-[#374151]',
    'tier-featured': 'bg-[#DBEAFE] text-[#1D4ED8]',
    'tier-spotlight': 'bg-[#FEF3C7] text-[#B45309]',
    'tier-premium': 'bg-[#FEF3C7] text-[#B45309]',    // Same as spotlight
    
    // Outline variants
    'outline-default': 'border border-border text-text-primary bg-transparent',
    'outline-primary': 'border border-primary text-primary bg-transparent',
    'outline-success': 'border border-success text-success bg-transparent',
    'outline-warning': 'border border-warning text-warning bg-transparent',
    'outline-danger': 'border border-error text-error bg-transparent',
    
    // Solid variants
    'solid-default': 'bg-secondary text-white',
    'solid-primary': 'bg-primary text-white',
    'solid-success': 'bg-success text-white',
    'solid-warning': 'bg-warning text-white',
    'solid-danger': 'bg-error text-white'
  };

  // Sizes based on UX Base Design font sizes
  const sizes = {
    xs: 'px-2 py-0.5 text-xs',      // 12px text
    sm: 'px-2.5 py-0.5 text-xs',    // 12px text, slightly more padding
    md: 'px-3 py-1 text-sm',        // 14px text
    lg: 'px-3.5 py-1.5 text-sm'     // 14px text, more padding
  };

  const classes = clsx(
    baseClasses,
    variants[variant],
    sizes[size],
    className
  );

  return (
    <span className={classes} {...props} data-otg-component={props['data-otg-component'] || 'Badge'}>
      {children}
    </span>
  );
};

export default Badge;
